import getNumberWithOrdinalSuffix from '../getNumberWithOrdinalSuffix';

// e.g. Dec. 25th, Feb. 1st, May 2nd
function getMonthAndDayWithOrdinalSuffix(date: Date | string) {
  const dateString = new Date(date).toDateString();
  const monthDay = dateString.split(' ').slice(1, 3);
  const [month, dayOfMonth] = monthDay;
  const dayOfMonthWithOrdinal = getNumberWithOrdinalSuffix(
    parseInt(dayOfMonth, 10)
  );

  return `${month}. ${dayOfMonthWithOrdinal}`;
}

export default getMonthAndDayWithOrdinalSuffix;
